import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchReportsMetaData } from 'src/features/reporting/thunks/fetchReportsMetaData';
import { DIResult } from 'src/networking/api';
import { ReportsMetaDataResponse } from 'src/types/reportingTypes';
import { ScheduledReport } from 'src/types/scheduledReportTypes';

export const fetchScheduledReports = createAsyncThunk<
	ScheduledReport[],
	FetchScheduledReportDataPayload,
	{ rejectValue: string }
>(
	'scheduling/fetchScheduledReports',
	async ({ api, id }, { dispatch, rejectWithValue }) => {
		try {
			const response = await api.getScheduledReports(id);
			dispatch(fetchReportsMetaData({ api, id }));
			return response.data;
		} catch (error) {
			const message =
				error instanceof Error
					? error.message
					: 'An unexpected error occurred';
			return rejectWithValue(message);
		}
	},
);

type FetchScheduledReportDataPayload = {
	api: {
		getScheduledReports: (
			id: string,
		) => Promise<DIResult<ScheduledReport[]>>;
		getUnifiedReportingMetaData: (
			id: string,
		) => Promise<ReportsMetaDataResponse>;
	};
	id: string;
};
